import { WithdrawalPixType } from "../../interfaces/withdrawal";

interface PixTypeLabelProps {
    value?: WithdrawalPixType | null;
}

const types: Record<WithdrawalPixType | "default", string> = {
    cpf_cnpj: "CPF/CNPJ",
    phone: "Telefone",
    email: "E-mail",
    random: "Chave aleatória",
    default: "Não definido",
};

export function PixTypeLabel({ value }: PixTypeLabelProps) {
    const type = value ? types[value] ?? types.default : types.default;
    return <span>{type}</span>;
}
